import { RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { PreloadedQuery } from "react-relay";
import { WATaskSingleSettingsSelectTaskQuery } from "./WATaskSingleSettings/__generated__/WATaskSingleSettingsSelectTaskQuery.graphql";

export const WATaskSingleSettingsStack =
  createNativeStackNavigator<WATaskSingleSettingsParamList>();

type WATaskSingleSettingsParamList = {
  WATaskSingleSettingsSelectRoutine: object;
  WATaskSingleSettingsSelectTask: {
    queryRef: PreloadedQuery<WATaskSingleSettingsSelectTaskQuery>;
  };
  WATaskSingleSettings: object;
};

export type WATaskSingleSettingsScreenProps<
  T extends keyof WATaskSingleSettingsParamList,
> = {
  route: RouteProp<WATaskSingleSettingsParamList, T>;
  navigation: NativeStackNavigationProp<WATaskSingleSettingsParamList, T>;
};
